module.exports = __webpack_public_path__ + "img/lsftd.0df6d256.jpg";